import { css } from '@emotion/core'
import { measures } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

// Common width for both inputs and dropdowns
const inputWidth = `${35 * unit}px` // Adjust this value to match dropdown width

export const row = css`
  display: flex;
  align-items: center;
  min-height: ${8 * unit}px;
  width: 100%;
  max-width: 800px;
  
  ${MQ.PHONES} {
    justify-content: space-between;
  }

  & label {
    min-width: ${12 * unit}px;
    flex: 0 0 ${12 * unit}px;
  }

  & > div:nth-of-type(1) {
    width: ${inputWidth};  // Use common width
    min-width: 0;
  }
`

// Regular input control - match dropdown width
export const control = css`
  width: ${inputWidth};  // Use common width
  &:disabled {
    background-color: transparent;
  }
`

// Dropdown control
export const dropdownControl = css`
  width: ${inputWidth};  // Use common width
  &:disabled {
    background-color: transparent;
  }
`

export const select = {
  control: (state) => ({
    minHeight: '50px',
    width: '100%',
    backgroundColor: state.isDisabled ? 'transparent' : '#2A2C33',
  }),
  indicatorsContainer: (state) => {
    if (state.isDisabled) {
      return { display: 'none' }
    }
  },
}

export const rowWithToggle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const formWrapper = css`
  padding: ${3 * unit}px;
  width: 100%;
`
